export default __webpack_public_path__ + "static/media/eyeOff-icon.57d12c9b.svg";